<template>
  <transition name="fade">
    <div
      class="idle-overlay"
      v-if="show"
    >
      <div class="idle-minimal-content">
        <div class="idle-header">
          <p class="idle-subtitle">
            Your order will be cancelled due to inactivity.
          </p>
          <p class="idle-tap-hint">
            Tap anywhere to continue ordering
          </p>
        </div>

        <div class="countdown-section">
          <div class="countdown-timer">
            <svg
              class="countdown-svg"
              viewBox="0 0 100 100"
            >
              <circle
                class="countdown-bg"
                cx="50"
                cy="50"
                r="45"
              />
              <circle
                class="countdown-progress"
                cx="50"
                cy="50"
                r="45"
                :style="{ strokeDashoffset: strokeDashoffset }"
              />
            </svg>
            <div class="countdown-value">
              <span class="seconds">{{ secondsLeft }}</span>
              <span class="label">seconds</span>
            </div>
          </div>
        </div>
        <div class="idle-actions">
          <button
            class="leave-btn"
            @click="$emit('leave')"
          >
            Cancel Order & Exit
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "IdleTimeoutOverlay",
  props: {
    show: Boolean,
    secondsLeft: Number,
    totalSeconds: {
      type: Number,
      default: 60,
    },
  },
  computed: {
    strokeDashoffset() {
      const radius = 45;
      const circumference = 2 * Math.PI * radius;
      return (
        circumference - (this.secondsLeft / this.totalSeconds) * circumference
      );
    },
  },
};
</script>

<style scoped>
.idle-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.9);
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  color: white;
}

.idle-minimal-content {
  width: 100%;
  max-width: 600px;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 40px;
  animation: contentFadeUp 0.6s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes contentFadeUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.warning-icon {
  width: 80px;
  height: 80px;
  background: rgba(245, 158, 11, 0.2);
  color: #f59e0b;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px;
}

.warning-icon svg {
  width: 40px;
  height: 40px;
}

.idle-title {
  font-size: 48px;
  font-weight: 900;
  color: white;
  margin: 0 0 16px 0;
  font-family: "Merriweather", serif;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

.idle-subtitle {
  color: white;
  font-size: 24px;
  font-weight: 700;
  margin: 0;
  line-height: 1.4;
  text-shadow: 0 1px 5px rgba(0, 0, 0, 0.2);
}

.idle-tap-hint {
  color: rgba(255, 255, 255, 0.6);
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  margin-top: 12px;
}

.countdown-section {
  display: flex;
  justify-content: center;
}

.countdown-timer {
  position: relative;
  width: 200px;
  height: 200px;
}

.countdown-svg {
  width: 100%;
  height: 100%;
  transform: rotate(-90deg);
}

.countdown-bg {
  fill: none;
  stroke: rgba(255, 255, 255, 0.1);
  stroke-width: 4;
}

.countdown-progress {
  fill: none;
  stroke: #3b82f6;
  stroke-width: 6;
  stroke-linecap: round;
  stroke-dasharray: 282.7;
  transition: stroke-dashoffset 1s linear;
}

.countdown-value {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.seconds {
  font-size: 64px;
  font-weight: 900;
  color: white;
  line-height: 1;
}

.label {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.5);
  font-weight: 600;
  text-transform: uppercase;
  margin-top: 4px;
}

.idle-actions {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
}

.stay-btn {
  background: white;
  color: #0f172a;
  border: none;
  padding: 24px;
  border-radius: 16px;
  font-size: 24px;
  font-weight: 800;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
}

.stay-btn:hover {
  background: #f8fafc;
  transform: scale(1.02);
}

.leave-btn {
  background: transparent;
  color: rgba(255, 255, 255, 0.5);
  border: none;
  padding: 12px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.leave-btn:hover {
  color: #ef4444;
}

/* Transitions */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
